// alterar arquivo: public/index.html
// substituir imagens: public/img
// substituir favicon: /public/favicon.ico
// checar se existe código do google analytics (apagar ou substituir se for o caso)

// alterar arquivos: .firebaserc, firebase.json e package.json com o nome do projeto no firebase

// color primary: public/assets/switcher/css/color2.css
// color secondary: public/assets/switcher/css/color2.css: 135

export const nome_revenda = "Divel Veículos";
export const url_revenda  = "https://www.divelveiculosto.com.br";
export const id_firebase  = "JUK0HkhCTFuFtyfp1HaC";
export const texto_sobre_nos = "As melhores taxas de financiamento! A melhor avaliação de seu usado na troca. Venda, troca, financiamento e consignação.";
export const horario_seg_sex = "8:00 - 18:00";
export const horario_sab = "8:00 - 12:00";
export const endereco = "Rua Aquiles de Pina, 223 - Setor Sul";
export const cidade = "Araguaína - TO";
export const telefone = "(63) 99246-7709";
export const telefone_link = "63992467709";
export const whatsapp = "(63) 99246-9700";
export const whatsapp_link = "https://api.whatsapp.com/send?phone=5563992469700";
export const email = "contato@divelaraguainato.com.br";
export const mapa_link = "https://www.google.com/maps/place/R.+Aquiles+de+Pina,+223+-+St.+Sul,+Aragua%C3%ADna+-+TO,+77818-190/@-7.1881099,-48.2196592,17z/data=!3m1!4b1!4m5!3m4!1s0x92d90da2db718745:0xae68f327e22c64da!8m2!3d-7.1881152!4d-48.2174705";
export const instagram_link = "https://www.instagram.com/divel.araguaina/";
export const facebook_link = "https://www.facebook.com/divel.veiculo";
